import { ChevronRight } from 'lucide-react';
import type { ReactNode } from 'react';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/ui/collapsible';
import { cn } from '@/lib/utils';

/**
 * "Ver mais" que abre no lugar: detalhe que quase ninguém precisa, mas que precisa existir — o
 * JSON completo, as regras de segurança, todos os dados enviados à IA. Fechado por padrão.
 */
export function Disclosure({
  summary,
  children,
  size = 'sm',
  defaultOpen = false,
  className,
}: {
  summary: ReactNode;
  children: ReactNode;
  size?: 'xs' | 'sm';
  /** Aberto de início quando o detalhe é o assunto da tela (ex.: a conta do único anúncio). */
  defaultOpen?: boolean;
  className?: string;
}) {
  return (
    <Collapsible
      defaultOpen={defaultOpen}
      className={cn(size === 'xs' ? 'text-xs' : 'text-sm', className)}
    >
      <CollapsibleTrigger className="group flex items-center gap-1 text-muted-foreground hover:text-foreground">
        <ChevronRight
          aria-hidden
          className="size-4 transition-transform group-data-[state=open]:rotate-90"
        />
        {summary}
      </CollapsibleTrigger>
      <CollapsibleContent className="mt-2">{children}</CollapsibleContent>
    </Collapsible>
  );
}
